export const subscriptionProductsExcludedFromFreeTrial = ["gooa-01", "msop-01", "msop-02"];
